// Svelte-Action: haengt den Node an <body> statt ihn an seiner Stelle im
// Komponentenbaum zu lassen.
//
// Warum: Vollflaechen-Overlays (fixed inset-0) leben sonst INNERHALB von
// <main>, und <main> traegt die `content-top-fade`-Maske (die oberen
// ~4.5rem werden transparent, damit Inhalt unter die schwebende TopBar
// faded). Diese Maske beschneidet auch den Overlay-Backdrop -> der
// Blur/Dim "stuft" an der TopBar-Kante ab. Ausserdem macht ein maskierter/
// transformierter Vorfahre `position:fixed` zu SEINEM Containing-Block.
// An <body> gehaengt deckt der Backdrop den ganzen Viewport gleichmaessig
// ab. Svelte entfernt den Node beim Unmount; destroy raeumt zusaetzlich
// explizit auf (doppeltes rem() ist ein No-op).
//
// Der Bereich geht mit: ein Dialog gehört zu der Seite, die ihn öffnet.
// An <body> gehängt verlöre er deren Farbe (data-bereich an der
// Seitenfläche, app.css „Farbe") -- ein oranger Knopf im Dialog über einer
// türkisen Seite. Darum trägt der Knoten den Bereich seines Ursprungs
// selbst, sofern er keinen eigenen hat.
export function portal(node: HTMLElement) {
  bereichMitnehmen(node);
  document.body.appendChild(node);
  return { destroy: () => node.remove() };
}

/** Vor dem Umhängen an <body> aufrufen: der Knoten trägt danach den
 *  Bereich seines Ursprungs (s.o.). Auch anchoredPopover nutzt das --
 *  ein Menü gehört ebenso zu der Seite, die es öffnet. */
export function bereichMitnehmen(node: HTMLElement): void {
  if (node.dataset.bereich) return;
  const bereich = node.parentElement?.closest<HTMLElement>("[data-bereich]")?.dataset.bereich;
  if (bereich) node.dataset.bereich = bereich;
}
